// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// // Import modules from 'swiper/modules'
// import { Pagination, Autoplay } from "swiper/modules";


// // Import Swiper styles
// import "swiper/css";
// import "swiper/css/pagination";

// const BestFoodItems = () => {
//   const foodItems = [
//     {
//       title: "Kaju Karela Royal Delight",
//       text: "Royal spices, cashew richness, perfectly balanced.",
//       price: "₹220",
//       img: "/assets/img/food-items/kaju_karela.png",
//     },
//     {
//       title: "House Special Draksh Pickle",
//       text: "Sweet-tangy grapes with traditional spice magic.",
//       price: "₹180",
//       img: "/assets/img/food-items/aachar.jpg",
//     },
//     {
//       title: "Chiku Halvo Rajwadi Mithaas",
//       text: "Rich, smooth halwa with royal sweetness.",
//       price: "₹240",
//       img: "/assets/img/food-items/halvo.jpg",
//     },
//     {
//       title: "Poha Dhokla Celebration Bite",
//       text: "Soft, airy, and lightly spiced perfection.",
//       price: "₹150",
//       img: "/assets/img/food-items/poha-dhokla.jpg",
//     },
//   ];

//   return (
//     <section className="best-food-items-section fix section-padding bg-color2">
//       <div className="best-food-wrapper">
//         {/* Shapes */}
//         <div className="shape1 float-bob-y d-none d-xxl-block">
//           <img
//             src="/assets/img/shape/bestFoodItemsShape1_1.png"
//             alt="shape"
//           />
//         </div>
//         <div className="shape2 float-bob-x d-none d-xxl-block">
//           <img
//             src="/assets/img/shape/bestFoodItemsShape1_2.png"
//             alt="shape"
//           />
//         </div>

//         <div className="container">
//           {/* Title */}
//           <div className="title-area">
//             <div
//               className="sub-title text-center wow fadeInUp"
//               data-wow-delay="0.5s"
//             >
//               <img
//                 className="me-1"
//                 src="/assets/img/icon/titleIcon.svg"
//                 alt="icon"
//               />
//               Best Food
//               <img
//                 className="ms-1"
//                 src="/assets/img/icon/titleIcon.svg"
//                 alt="icon"
//               />
//             </div>
//             <h2 className="title wow fadeInUp" data-wow-delay="0.7s">
//               A Grand Feast of Flavours
//             </h2>
//           </div>

//           {/* Swiper Slider */}
//              <Swiper
//                     modules={[Autoplay]}
//                     loop={true}
//                     loopAdditionalSlides={4}     // VERY IMPORTANT
//                     slidesPerView={3}
//                     spaceBetween={30}
//                     speed={6000}
//                     autoplay={{
//                       delay: 0,
//                       disableOnInteraction: false,
//                     }}
//                     allowTouchMove={false}
//                     breakpoints={{
//                       0: { slidesPerView: 1 },
//                       768: { slidesPerView: 2 },
//                       1200: { slidesPerView: 3 },
//                     }}
//                   >
//                   {foodItems.map((item, index) => (
//                       <SwiperSlide key={index}>
//                             <div className="single-food-items">
//                               <div className="item-thumb">
//                                 <img src={item.img} alt="thumb" />
//                                 <div className="circle-shape">
//                                   <img
//                                     className="cir36"
//                                     src="/assets/img/food-items/circleShape.png"
//                                     alt="shape"
//                                   />
//                                 </div>
//                               </div>
//                               <div className="item-content">
//                                 <a href="/menu">
//                                   <h3>{item.title}</h3>
//                                 </a>
//                                 <div className="text">{item.text}</div>
//                                 {/* <h6>{item.price}</h6> */}
//                               </div>
//                             </div>
//                 </SwiperSlide>
//               ))}
//             </Swiper>

//             {/* Pagination */}
//             <div className="bestFoodItems-pagination"></div>
//           </div>
//         </div>
      
//     </section>
//   );
// };

// export default BestFoodItems;



import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, FreeMode } from "swiper/modules"; // Added FreeMode

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";

const BestFoodItems = () => {
  const foodItems = [
    {
      title: "Kaju Karela Royal Delight",
      text: "Spices, cashew richness, perfectly balanced.",
      img: "/assets/img/food-items/kaju_karela.png",
    },
    {
      title: "House Special Draksh Pickle",
      text: "Sweet-tangy grapes with traditional spice magic.",
      img: "/assets/img/food-items/aachar.jpg",
    },
    {
      title: "Chiku Halvo Rajwadi Mithaas",
      text: "Rich, smooth halwa with royal sweetness.",
      img: "/assets/img/food-items/halvo.jpg",
    },
    {
      title: "Dhokla Celebration Bite",
      text: "Soft, airy, and lightly spiced perfection.",
      img: "/assets/img/food-items/poha-dhokla.jpg",
    },
  ];

  return (
    <section className="best-food-items-section fix section-padding bg-color2">
      <div className="best-food-wrapper">
        <div className="container">
          <div className="title-area text-center mb-50">
            <div className="sub-title">
              <img className="me-1" src="/assets/img/icon/titleIcon.svg" alt="icon" />
              Best Food
              <img className="ms-1" src="/assets/img/icon/titleIcon.svg" alt="icon" />
            </div>
            <h2 className="title">A Grand Feast of Flavours</h2>
          </div>

          <Swiper
            modules={[Autoplay, Pagination, FreeMode]}
            loop={true}
            speed={6000} // Speed of the movement
            freeMode={true} // Essential for continuous slide
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false, // Set to true if you want it to stop on hover
            }}
            allowTouchMove={true} // Allow swiping on both desktop and mobile
            breakpoints={{
              0: { 
                slidesPerView: 1.2, // Show a bit of the next slide on mobile
                spaceBetween: 20 
              },
              768: { 
                slidesPerView: 2.5, 
                spaceBetween: 30 
              },
              1200: { 
                slidesPerView: 4, // 4 Items on Desktop
                spaceBetween: 30 
              },
            }}
            className="food-item-slider"
          >
            {foodItems.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="single-food-items">
                  <div className="item-thumb">
                    <img src={item.img} alt={item.title} />
                    <div className="circle-shape">
                      <img className="cir36" src="/assets/img/food-items/circleShape.png" alt="shape" />
                    </div>
                  </div>
                  <div className="item-content">
                    <a href="/menu">
                      <h3>{item.title}</h3>
                    </a>
                    <div className="text">{item.text}</div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default BestFoodItems;
